import * as React from 'react';
export const useMemoizedHTML = (rawHTML = '') => React.useMemo(() => ({
  __html: rawHTML
}), [rawHTML]);